import { useEffect, useState } from "react";
import { Loader2, Trash2, UserPlus, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const AdminsDialog = ({ open, onOpenChange, t }) => {
  const [list, setList] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/auth/admins").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (open) { setList(null); load(); } }, [open]);

  const add = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try { await api.post("/auth/admins", { email: email.trim() }); setEmail(""); load(); }
    catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  const remove = async (em) => { try { await api.delete(`/auth/admins/${encodeURIComponent(em)}`); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="admins-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-primary" />{t("approved_admins")}</DialogTitle>
          <DialogDescription>{t("admin_access_note")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={add} className="flex gap-2" data-testid="add-admin-form">
          <Input type="email" required placeholder={t("admin_email_ph")} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="add-admin-email-input" />
          <Button type="submit" disabled={busy} data-testid="add-admin-submit-button">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />}</Button>
        </form>
        <div className="rounded-lg border border-border divide-y divide-border/60 max-h-[50vh] overflow-y-auto" data-testid="admins-list">
          {!list ? (
            <div className="py-8 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>
          ) : list.map((a) => (
            <div key={a.email} className="flex items-center gap-3 px-3 py-2.5" data-testid={`admin-row-${a.email}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{a.email}</div>
                <div className="text-xs text-muted-foreground">{a.role === "owner" ? t("owner") : t("admin_role")}</div>
              </div>
              {a.role !== "owner" && (
                <Button variant="ghost" size="icon" className="text-rose-400 hover:text-rose-300" data-testid={`remove-admin-${a.email}`} onClick={() => remove(a.email)}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
